import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./areas.component.html')
})
export class AreasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/areas.component.ts
 **/